<template>
  <div>
    <div class="d-flex">
      <div class="card m-1 flex-fill">
        <div class="card-body maadi-dark-card d-flex">
          <div class="m-1">
            <b-form-select v-model="filter.date" :options="dateFields"></b-form-select>
          </div>
          <div class="m-1" v-if="false">
            <b-form-select v-model="filter.compare_date" :options="dateFields"></b-form-select>
          </div>
          <div class="m-1">
            <b-form-select v-model="filter.member_type" :options="memberType"></b-form-select>
          </div>
          <div class="ml-auto">
            <button class="btn maadi-button" @click="setOrganizationData">
              SUBMIT
            </button>
          </div>
        </div>
      </div>
      <div class="card m-1" v-if="rankingData !== null">
        <div class="card-body maadi-dark-card d-flex">
          <div class="m-1">
            <b-form-select v-model="accountIDToHighlight" :options="organizationOptions"></b-form-select>
          </div>
        </div>
      </div>
    </div>
    <title-bar title="THIS FEATURE IS NOT UP TO DATE OR CURRENTLY BEING DEVELOPED"/>
    <div v-if="rankingData !== null">
      <div class="" v-for="statisticObject in getStatistics()" :key="statisticObject.title">
        <title-bar v-bind:title="statisticObject.title" v-bind:description="statisticObject.description"/>
        <div>
          <div class="d-flex flex-fill" v-for="statistic in statisticObject.statistics" :key="statistic.title">
            <div class="flex-fill card-group" v-for="singleStatistic in statistic" :key="singleStatistic.title">
              <ranked-statistic class="m-1" v-bind:account-i-d="accountIDToHighlight" v-bind:ranked-statistic="singleStatistic"></ranked-statistic>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RankedStatistic from './RankedStatistic'
import RankingStatisticsMixin from './RankingStatisticsMixin'
import TitleBar from '../../homePage/TitleBar'

export default {
  name: '',
  data: function () {
    return {
    }
  },
  mixins: [
    RankingStatisticsMixin
  ],
  components: {
    RankedStatistic, TitleBar
  },
  computed: {
    organizations () {
      return this.rankingData.organizations
    },
    organizationOptions () {
      let optionsArray = [{text: '', value: null}]
      this.rankingData.organizations.forEach((x) => {
        optionsArray.push(
          {
            text: x.name,
            value: x.id
          }
        )
      })
      return optionsArray
    }
  },
  methods: {

  },
  mounted () {
    this.setOrganizationData()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/organizations/rankings/RankingsIndex.vue